export default "__VITE_ASSET__BYl5zqVY__"